export function isStoreCurrentlyOpen(today: any): boolean {
  if (!today || !today.open) {
    return false
  }

  const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }))
  const currentTime = now.getHours() * 60 + now.getMinutes()

  const [openHours, openMinutes] = today.open_time.split(':').map(Number)
  const [closeHours, closeMinutes] = today.close_time.split(':').map(Number)

  const openTime = openHours * 60 + openMinutes
  const closeTime = closeHours * 60 + closeMinutes

  if (currentTime >= openTime && currentTime <= closeTime) {
    return true
  }
  return false
}
